const classifyLabelColor = (data) => {
  switch (data) {
    case 'DELIVERED':
      return 'success-v2 fs-7';

    case 'PRINT':
      return 'warning fs-7';

    case 'INSTITUTION':
    case 'NO':
      return 'danger fs-7';

    case 'YES':
      return 'primary fs-7';
  }
  return;
};

const formatPaymentData = function (format, data) {
  let parseData = '';

  if (format === 'PAYMENT_METHOD') {
    switch (data) {
      case 'CASH':
        parseData = 'Cash';
        break;
      case 'CREDIT':
        parseData = 'Credit Card';
        break;
      case 'DEBIT':
        parseData = 'Debit Card';
        break;
      case 'TRANSFER':
        parseData = 'Bank Transfer';
        break;
      case 'QRIS':
        parseData = 'QRIS';
        break;
    }
  } else if (format === 'PAYMENT_TYPE') {
    switch (data) {
      case 'DEPOSIT':
        parseData = 'Deposit';
        break;
      case 'ENGLISH':
        parseData = 'ICAN English';
        break;
      case 'APPLICATION':
        parseData = 'Application Fee';
        break;
      case 'OTHERS':
        parseData = 'Others';
        break;
    }
  } else if (format === 'PROMOTION_TYPE') {
    const curObj = JSON.parse(data);

    for (let i = 0; i < curObj.length; i++) {
      if (i !== curObj.length - 1) {
        parseData += curObj[i].TYPE + ', ';
      } else {
        parseData += curObj[i].TYPE;
      }
    }
  }

  return parseData;
};

const generateUniversityBudget = function (data) {
  let curString = '';

  for (let i = 0; i < data.length; i++) {
    // Parse Number
    let finalNumber = '';

    if (Number.isInteger(data[i].value)) {
      finalNumber = parseInt(data[i].value).toLocaleString('id-ID');
    } else {
      finalNumber = parseFloat(data[i].value).toFixed(2);
    }

    curString += `
      <div class="col-md-3">
        <div class="input-group mb-2 mr-5">
          <div class="input-group-prepend">
            <div class="input-group-text fw-bolder">
              ${data[i].currency}
            </div>
          </div>
          <input type="text" disabled class="form-control fw-bolder text-dark" value="${finalNumber}" />
        </div>
      </div>
      `;
  }

  return curString;
};

var globalTypingTimer;
const calculatedTotal = (type, targetElem, number1, number2, globalDoneTypingInterval = 2000, elementKTBlock = null) => {
  var result = 0,
    valueOne = $(number1).cleanVal() ? parseInt($(number1).cleanVal()) : 0,
    valueTwo = $(number2).val() ? parseInt($(number2).val()) : 0;

  if (valueTwo > 100) {
    Swal.fire({
      title: 'Warning!',
      icon: 'warning',
      html: 'PPN maksimal 100%, silahkan masukkan ppn antara 1 - 100 %',
      showCancelButton: false,
      confirmButtonText: 'Close',
    });
    $('#btn-submit-budget').prop('disabled', true);
    return;
  }
  $('#btn-submit-budget').prop('disabled', false);

  clearTimeout(globalTypingTimer);
  globalTypingTimer = setTimeout(() => {
    if (type == 'percentase') {
      let temp = (valueOne * valueTwo) / 100;
      if (valueTwo !== 0) {
        result = valueOne + parseInt(temp);
      } else {
        result = valueOne;
      }
    } else {
      result = valueOne * valueTwo;
    }
    $(targetElem).unmask();
    $(targetElem).val(result);
    $(targetElem).mask('000.000.000.000.000', { reverse: true });

    if (elementKTBlock !== null) {
      KTApp.unblock(elementKTBlock);
    }
  }, globalDoneTypingInterval);
};

const initTimePicker = (elem) => {
  $(elem)
    .daterangepicker({
      timePicker: true,
      timePicker24Hour: true,
      timePickerIncrement: 5,
      locale: { format: 'HH:mm', cancelLabel: 'Clear' },
      buttonClasses: ' btn',
      applyClass: 'btn-primary',
      cancelClass: 'btn-secondary',
    })
    .on('show.daterangepicker', function (ev, picker) {
      picker.container.find('.ranges').hide();
      picker.container.find('.calendar-table').hide();
    });
};

export { classifyLabelColor, calculatedTotal, initTimePicker, generateUniversityBudget, formatPaymentData };
